import React, { useState } from 'react'
import {
  CompressOutlined,
  DatabaseOutlined,
  InsertRowAboveOutlined,
  OneToOneOutlined,
  TableOutlined,
  TabletOutlined,
  VerticalAlignTopOutlined
} from '@ant-design/icons'

const ShowIconSellGroup = props => {
  const role = props && props.type ? props.type : ''

  const ShowIcons = () => {
    switch (role) {
      case 'Table':
        return (
          <>
            <TabletOutlined />
          </>
        )
      case 'Floor':
        return (
          <>
            <DatabaseOutlined />
          </>
        )
      case 'OneTwoOne':
        return (
          <>
            <OneToOneOutlined />
          </>
        )
      case 'Corners':
        return (
          <>
            <CompressOutlined />
          </>
        )
      case 'LongTable':
        return (
          <>
            <InsertRowAboveOutlined />
          </>
        )
      case 'Roof':
        return (
          <>
            <VerticalAlignTopOutlined />
          </>
        )
      default:
        return <></>
    }
  }

  return <ShowIcons />
}

export default ShowIconSellGroup
